export var useTabs = _ref => {
  var {
    tabs,
    onChange,
    activeTabIndex,
    tabsRefs
  } = _ref;

  var handleKeyDown = e => {
    if (e.key === 'ArrowRight') {
      var _tabsRefs$rightTabInd, _tabsRefs$rightTabInd2;

      var rightTabIndex = activeTabIndex === tabs.length - 1 ? 0 : activeTabIndex + 1;
      (_tabsRefs$rightTabInd = tabsRefs[rightTabIndex]) === null || _tabsRefs$rightTabInd === void 0 ? void 0 : (_tabsRefs$rightTabInd2 = _tabsRefs$rightTabInd.current) === null || _tabsRefs$rightTabInd2 === void 0 ? void 0 : _tabsRefs$rightTabInd2.focus();
      onChange(tabs[rightTabIndex].name);
    }

    if (e.key === 'ArrowLeft') {
      var _tabsRefs$leftTabInde, _tabsRefs$leftTabInde2;

      var leftTabIndex = activeTabIndex === 0 ? tabs.length - 1 : activeTabIndex - 1;
      (_tabsRefs$leftTabInde = tabsRefs[leftTabIndex]) === null || _tabsRefs$leftTabInde === void 0 ? void 0 : (_tabsRefs$leftTabInde2 = _tabsRefs$leftTabInde.current) === null || _tabsRefs$leftTabInde2 === void 0 ? void 0 : _tabsRefs$leftTabInde2.focus();
      onChange(tabs[leftTabIndex].name);
    }
  };

  return {
    handleKeyDown
  };
};
//# sourceMappingURL=useTabs.js.map